__turbopack_context__.v({
  "darktext": "Gdjb0G_darktext",
  "rowSwapped": "Gdjb0G_rowSwapped",
  "splitview": "Gdjb0G_splitview",
  "splitviewcode": "Gdjb0G_splitviewcode",
  "splitviewtext": "Gdjb0G_splitviewtext",
  "swapped": "Gdjb0G_swapped",
});
